import axios from "axios";

export const getUserResetPasswordWeb = async (id:number) => {
    return await axios({
		url: `/User/resetPasswordWeb?id=${id}`,
		method: "GET",
	});
}